import React from "react";
import { Link } from "react-router-dom";

const PageNavigationLink = ({
  title,
  navigateTo,
  stateObj,
  className,
  onClick,
}) => {
  return (
    <Link
      to={navigateTo}
      state={stateObj.state}
      className={className}
      onClick={onClick}
    >
      {title}
    </Link>
  );
};

export default PageNavigationLink;
